<script>
export default {
  props: {
    value: [String, Array],
  },

  data: () => ({
    personNames: [],
  }),
}
</script>

<template>
  <api-loader
    method="get"
    url="v1/layers/distinct-person-names"
    @loaded="personNames=$event"
    :show-busy="false"
    :show-error="false">

    <div class="position-relative" slot-scope="{busy, error}">

      <b-form-group label="Person" :label-for="`input-${_uid}`">
        <b-input-group>

          <b-form-input :value="value"
            @input="$emit('input', $event)"
            @change="$emit('change', $event)"
            @focus="$event.target.select()"
            :id="`input-${_uid}`"
            v-bind="$attrs"
            type="text"
            class="form-control">
          </b-form-input>

          <b-dropdown slot="append" variant="outline-secondary">
            <template slot="button-content">
              <b-spinner v-if="busy" small type="grow" label="Loading..." />
              Choose
            </template>
            <b-dropdown-item v-for="name in personNames" :key="name" @click="$emit('input', name)">{{name}}</b-dropdown-item>
          </b-dropdown>

        </b-input-group>

        <div v-if="error" class="text-right text-danger">{{error}}</div>
      </b-form-group>

    </div>
  </api-loader>
</template>



// WEBPACK FOOTER //
// src/layer/components/LayerPersonChooser.vue